// Khoa don gian bang localStorage: neu nhieu tab CRM cung mo tren 1 may,
// chi tab nao dang giu khoa con hieu luc moi duoc quet - tranh gui trung.
export const createPollerLock = (lockKey, ttlMs) => {
	const tabId = Math.random().toString(36).slice(2);
	return () => {
		try {
			const raw = localStorage.getItem(lockKey);
			const now = Date.now();
			if (raw) {
				const { tabId: owner, ts } = JSON.parse(raw);
				if (owner !== tabId && now - ts < ttlMs) {
					return false;
				}
			}
			localStorage.setItem(lockKey, JSON.stringify({ tabId, ts: now }));
			return true;
		} catch (e) {
			return true;
		}
	};
};
